import Image from 'next/image';
import { useEffect, useState } from 'react';
import AlertDialog from '../Utils/AlertDialog';
import axios from 'axios';


const Partner = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleSubmit = async () => {
    if (name === "") {
      setAlertMessage("Please fill in your name");
    } else if (email === "") {
      setAlertMessage("Please fill in your email");
    } else if (company === "") {
      setAlertMessage("Please fill in the company name");
    } else if (message === "") {
      setAlertMessage("Please fill in the message");
    } else {
      try {
        const response = await axios.post(
          '/api/contact-us',
          {
            name: name,
            email: email,
            company: company,
            message: message
          }
        );

        if (response.data.status === "ok") {
          setAlertMessage("Your Email Has Been Sent! We will get back to you as soon as possible, please check your email for further notifications.");
          setName("");
          setEmail("");
          setCompany("");
          setMessage("");
        } else {
          setAlertMessage("Failed to send email. Please try again later.");
        }
      } catch (error) {
        setAlertMessage("Failed to send email. Please try again later.");
      }
    }
  }

  useEffect(() => {
    if (alertMessage !== "") {
      setOpen(true);
    }
  }, [alertMessage])

  useEffect(() => {
    if (!open) {
      setAlertMessage("");
    }
  }, [open])


  return (
    <div className="w-full grid gird-cols-1 md:grid-cols-2 gap-12 md:items-center mb-[69px] md:mb-0">
      <div className="hidden md:block w-full">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/partner-desktop.jpg"}
          alt="be our partner image"
          width={900}
          height={922}
          quality={100}
        />
      </div>
      <div className="md:hidden w-full">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/partner-desktop.jpg"}
          alt="be our partner image"
          width={900}
          height={600}
          quality={100}
        />
      </div>
      <div className="mx-[35px] md:mx-auto md:w-[400px] font-dmsans">
        <h1 className="hidden md:block text-[32px] leading-normal font-bold text-[#2C3E2F] text-left">Be Our Partner</h1>
        <h1 className="md:hidden text-[24px] leading-normal font-bold text-[#2C3E2F] text-center">Are You  Interested to be Our Partner?</h1>
        <div className="flex mt-2 text-sm font-normal text-[#2C3E2F] text-center md:text-left">
          Green Parenting provides quality products at affordable prices for all mothers. Please contact us if you are interested in our products. We will be very happy to be able to work with you!
        </div>
        <input
          type="text"
          name="name"
          value={name}
          placeholder="Name"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setName(event.target.value)}
        />
        <input
          type="input"
          name="email"
          value={email}
          placeholder="Email"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setEmail(event.target.value)}
        />
        <input
          type="input"
          name="company"
          value={company}
          placeholder="Company Name"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setCompany(event.target.value)}
        />
        <textarea
          rows={5}
          name="message"
          value={message}
          placeholder="Message"
          className="w-full py-4 px-8 mt-6 text-sm placeholder:text-[#C6C6C6] border border-[#C6C6C6]"
          onChange={event => setMessage(event.target.value)}
        ></textarea>
        <button
          className="bg-[#A6CAA6] w-full text-white text-base font-medium py-4 px-12 text-center mt-6"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
      <AlertDialog
        open={open}
        setOpen={setOpen}
        message={alertMessage}
      />
    </div>
  )
}

export default Partner
